module.exports = __webpack_public_path__ + "static/media/valor4_2.f7ad90b5.mp4";